// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let IconV5 = require("../../uikit/atoms/Icon/IconV5.bs.js");
let Scalars = require("../../scalars/Scalars.bs.js");
let UTCDate = require("../../reason/common/types/UTCDate.bs.js");
let V4 = require("uuid/v4");
let DateFns = require("date-fns");
let ButtonsV5 = require("../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
let Link = require("next/link").default;
let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let ConfirmDialog = require("../../reason/common/ConfirmDialog/ConfirmDialog.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let SystemMessages = require("../../reason/systemMessages/SystemMessages.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
let MyBroadcastMessagesWidgetListItem_message_graphql = require("../../__generated__/MyBroadcastMessagesWidgetListItem_message_graphql.bs.js");
let MyBroadcastMessagesWidgetListItem_DeleteMessageBroadcastMutation_graphql = require("../../__generated__/MyBroadcastMessagesWidgetListItem_DeleteMessageBroadcastMutation_graphql.bs.js");

let convertFragment = MyBroadcastMessagesWidgetListItem_message_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, MyBroadcastMessagesWidgetListItem_message_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(MyBroadcastMessagesWidgetListItem_message_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, MyBroadcastMessagesWidgetListItem_message_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(MyBroadcastMessagesWidgetListItem_message_graphql.node, convertFragment, fRef);
}

let BroadcastMessageFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function MyBroadcastMessagesWidgetListItem$ConfirmDeleteDialog(props) {
  let onCancel = props.onCancel;
  let onConfirm = props.onConfirm;
  return JsxRuntime.jsx(ConfirmDialog.make, {
    title: "Delete Broadcast Message?",
    ariaLabel: "Confirm Delete Broadcast Message",
    body: JsxRuntime.jsxs(JsxRuntime.Fragment, {
      children: [
        JsxRuntime.jsx("div", {
          children: "Other users can no longer find the message nor start conversations about it. Conversations that you're already in can continue.",
          className: "leading-normal"
        }),
        JsxRuntime.jsx("br", {}),
        JsxRuntime.jsx("span", {
          children: "THIS CANNOT BE UNDONE",
          className: "font-bold"
        })
      ]
    }),
    isOpen: props.isOpen,
    onCancel: onCancel,
    cancelButton: JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
      onClick: param => onCancel(),
      children: "No, Keep Message"
    }),
    confirmButton: JsxRuntime.jsx(ButtonsV5.DangerButton.make, {
      onClick: param => onConfirm(),
      children: "Yes, Delete Message"
    })
  });
}

let ConfirmDeleteDialog = {
  make: MyBroadcastMessagesWidgetListItem$ConfirmDeleteDialog
};

function MyBroadcastMessagesWidgetListItem$DeleteBroadcastMessageButton(props) {
  let onDelete = props.onDelete;
  let match = React.useState(() => false);
  let setIsOpen = match[1];
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsx(MyBroadcastMessagesWidgetListItem$ConfirmDeleteDialog, {
        isOpen: match[0],
        onConfirm: () => {
          setIsOpen(param => false);
          onDelete();
        },
        onCancel: () => setIsOpen(param => false)
      }),
      JsxRuntime.jsxs(ButtonsV5.SecondaryButton.make, {
        onClick: param => setIsOpen(param => true),
        disabled: props.disabled,
        size: "small",
        children: [
          JsxRuntime.jsx(IconV5.make, {
            icon: "trash"
          }),
          JsxRuntime.jsx("div", {
            className: "ml-[8px]"
          }),
          "Delete"
        ]
      })
    ]
  });
}

let DeleteBroadcastMessageButton = {
  make: MyBroadcastMessagesWidgetListItem$DeleteBroadcastMessageButton
};

let convertVariables = MyBroadcastMessagesWidgetListItem_DeleteMessageBroadcastMutation_graphql.Internal.convertVariables;

let convertResponse = MyBroadcastMessagesWidgetListItem_DeleteMessageBroadcastMutation_graphql.Internal.convertResponse;

let convertWrapRawResponse = MyBroadcastMessagesWidgetListItem_DeleteMessageBroadcastMutation_graphql.Internal.convertWrapRawResponse;

let commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, MyBroadcastMessagesWidgetListItem_DeleteMessageBroadcastMutation_graphql.node, convertResponse, convertWrapRawResponse);

let use$1 = RescriptRelay_Mutation.useMutation(convertVariables, MyBroadcastMessagesWidgetListItem_DeleteMessageBroadcastMutation_graphql.node, convertResponse, convertWrapRawResponse);

let DeleteBroadcastMessageV5Mutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use$1
};

function MyBroadcastMessagesWidgetListItem(props) {
  let listConnectionId = props.listConnectionId;
  let message = RescriptRelay_Fragment.useFragment(MyBroadcastMessagesWidgetListItem_message_graphql.node, convertFragment, props.message);
  let match = use$1();
  let deleteBroadcastMessage = match[0];
  let match$1 = SystemMessages.useSystemMessages();
  let addMessage = match$1.addMessage;
  let match$2 = message.category;
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs(Link, {
            href: "/messages/" + message.id,
            className: "flex flex-col gap-1",
            children: [
              JsxRuntime.jsx("div", {
                children: match$2 !== undefined ? match$2.name : "",
                className: "text-gray-500 text-sm font-semibold uppercase tracking-wide"
              }),
              JsxRuntime.jsx("div", {
                children: Stdlib_Option.getOr(message.subject, ""),
                className: "text-lg font-medium"
              })
            ]
          }),
          JsxRuntime.jsx("div", {
            children: Stdlib_Option.getOr(Stdlib_Option.map(message.broadcastAt, s => DateFns.format(UTCDate.toUnzonedDate(Scalars.DateTime.toUTC(s)), "MM/dd/yyyy")), ""),
            className: "my-2 md:my-0"
          })
        ],
        className: "col-span-12 lg:col-span-6 flex flex-col md:flex-row md:justify-between md:items-center"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs(ButtonsV5.SecondaryButton.make, {
            href: `/messages/` + message.id + `/edit`,
            size: "small",
            children: [
              JsxRuntime.jsx(IconV5.make, {
                icon: "pencil",
                size: 15
              }),
              JsxRuntime.jsx("div", {
                className: "ml-[8px]"
              }),
              "Edit"
            ]
          }),
          JsxRuntime.jsx(MyBroadcastMessagesWidgetListItem$DeleteBroadcastMessageButton, {
            onDelete: () => {
              deleteBroadcastMessage({
                connections: Stdlib_Array.keepSome([listConnectionId]),
                messageBroadcastId: message.id
              }, undefined, undefined, undefined, (response, param) => {
                let match = response.deleteMessageBroadcast;
                if (match !== undefined && match.__typename === "MessageBroadcastWasDeleted") {
                  return addMessage(SystemMessages.Message.make(V4(), "info", "The message was deleted.", 5000, undefined, undefined));
                }
                addMessage(SystemMessages.Message.make(V4(), "error", "There was a problem deleting your message.", 5000, undefined, undefined));
              }, undefined, undefined);
            },
            disabled: match[1]
          })
        ],
        className: "col-span-12 lg:col-span-6 text-right flex flex-row space-x-2 md:justify-end items-center"
      })
    ],
    className: "grid grid-cols-12 gap-2 py-4 border-t"
  });
}

let make = MyBroadcastMessagesWidgetListItem;

exports.BroadcastMessageFragment = BroadcastMessageFragment;
exports.ConfirmDeleteDialog = ConfirmDeleteDialog;
exports.DeleteBroadcastMessageButton = DeleteBroadcastMessageButton;
exports.DeleteBroadcastMessageV5Mutation = DeleteBroadcastMessageV5Mutation;
exports.make = make;
/* commitMutation Not a pure module */
